import { ICONS } from './Icons'

export const Icon = (props) => {
    const {
        opacity = 1,
        fill = '#4D71AB',
        width = 24,
        height = 24,
        variant,
        onClick,
    } = props

    return (
        <span onClick={onClick}>
            <svg
                xmlns="http:www.w3.org/2000/svg"
                opacity={opacity}
                height={height}
                viewBox="0 0 24 24"
                width={width}
                fill={fill}
            >
                {ICONS[variant]}
            </svg>
        </span>
    )
}
